import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { get } from 'lodash';
import { Avatar, Box, List, ListItem, Typography } from '@mui/material';
import { History as HistoryIcon } from '@mui/icons-material';
import { Virtuoso } from 'react-virtuoso';
import useRescuerDashboardActions from '../../../../../hooks/useRescuerDashboardActions';
import { getRecentRescues } from '../../../../../helpers/RescuesHelper';
import RescueMobileCard from '../../../../Rescue/RescueMobileCard';
import useActiveUser from '../../../../../hooks/useActiveUser';
import RecentRescue from '../../../../../components/RescueNotification/RecentRescue';
import { Colors } from '../../../../../assets/theme/Colors';
import { StyledSubHeader } from '../myFrus/MyFrusMobile';

const containerSx = {
  position: 'relative',
  height: '100%',
  width: '100%',
  overflow: 'auto',
  backgroundColor: 'background.default',
};

const listSubItemSx = {
  padding: 1,
};

const customFooter = () => <Box sx={{ pb: 9 }} />;

const RecentRescuesMobile = () => {
  const activeUser = useActiveUser();
  const { fetchMyFrusTab } = useRescuerDashboardActions();
  const { formatMessage } = useIntl();
  const rescuesEntities = useSelector((state) => state.entities.rescues);
  const isLoading = get(rescuesEntities, `pastIds[${activeUser.id}].inflight`, true);
  const recentRescues = getRecentRescues(activeUser.id, rescuesEntities);
  const recentRescuesCount = recentRescues.length;

  useEffect(() => {
    fetchMyFrusTab(false, false);
  }, [activeUser.id, fetchMyFrusTab]);

  if (!isLoading && recentRescues.length === 0) {
    return (
      <Box sx={containerSx}>
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            WebkitTransform: 'translate(-50%, -50%)',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
          }}
        >
          <Typography color="textSecondary" variant="h5">
            {formatMessage({ id: 'rescuer-dashboard-mobile.my-rescues.no-claimed-rescues' })}
          </Typography>
        </Box>
      </Box>
    );
  }

  if (isLoading) {
    return (
      <List sx={containerSx} subheader={<li />}>
        <li style={{ backgroundColor: 'inherit' }}>
          <ul style={{ marginBottom: '16px', backgroundColor: 'inherit', padding: 0 }}>
            <ListItem sx={listSubItemSx}>
              <RescueMobileCard isLoading />
            </ListItem>
            <ListItem sx={listSubItemSx}>
              <RescueMobileCard isLoading />
            </ListItem>
            <ListItem sx={listSubItemSx}>
              <RescueMobileCard isLoading />
            </ListItem>
          </ul>
        </li>
      </List>
    );
  }

  return (
    <Box display="flex" flexDirection="column" width={1} pt={1}>
      {!isLoading && recentRescues.length > 0 && (
        <Box px={1}>
          <StyledSubHeader
            color={Colors.rescues.recent.color}
            text={formatMessage({ id: 'rescuer-dashboard-mobile.my-frus.recent-rescues' })}
            subText={formatMessage({ id: 'rescuer-dashboard-mobile.my-frus.recent-rescues-sub' })}
            icon={
              <Avatar
                sx={{ backgroundColor: Colors.rescues.recent.color, filter: 'brightness(0.9)' }}
              >
                <HistoryIcon />
              </Avatar>
            }
          />
        </Box>
      )}
      <Virtuoso
        style={{ width: '100%', height: '100%' }}
        components={{
          Footer: customFooter,
        }}
        totalCount={recentRescuesCount}
        itemContent={index => {
          const rescue = recentRescues[index];
          return (
            <Box key={`rescue-${rescue.id}`} sx={listSubItemSx}>
              <RecentRescue rescue={rescue} />
            </Box>
          );
        }}
      />
    </Box>
  );
};

export default RecentRescuesMobile;
